const testimonials = [
  {
    quote: "Having my medical information readily available gives me peace of mind, especially when traveling. The QR code system is brilliant—knowing first responders can access my allergies instantly is priceless.",
    author: "Maria Rodriguez",
    role: "Frequent Traveler",
  },
  {
    quote: "As someone with multiple allergies and chronic conditions, OLAID helps me ensure first responders know exactly what to avoid. It's literally a lifesaver that I carry everywhere.",
    author: "James Chen",
    role: "OLAID Health User",
  },
  {
    quote: "The group expense feature is perfect for our apartment. We scan receipts, split bills fairly, and everyone knows who owes what. No more awkward money conversations!",
    author: "Sarah Thompson",
    role: "Roommate Coordinator",
  },
  {
    quote: "The weekly cash flow summaries help me understand my spending patterns. Combined with the health QR code feature, OLAID covers both my emergency and financial planning needs.",
    author: "David Park",
    role: "Budget-Conscious Professional",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            What Users Are Saying
          </h2>
          <p className="text-xl text-gray-400">
            Join thousands of users who trust OLAID for their health and financial management
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-secondary-dark rounded-lg p-8 relative"
            >
              {/* Quote mark decoration */}
              <div className="absolute top-4 left-4 text-primary-light opacity-20">
                <svg
                  className="w-12 h-12"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>

              <div className="relative">
                <p className="text-gray-300 mb-6 italic">
                  "{testimonial.quote}"
                </p>
                <div>
                  <p className="font-semibold text-white">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-400 text-sm">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection; 